/**
 * src/lib/nav/vesselNav.js — directory vessel deep-link request.
 *
 * Race-free "open vessel V in the Directory" request — sibling of contactNav
 * (same shape). A global-search vessel/boat result sets this + switches to the
 * Directory tab; DirectoryView consumes it on mount / on a vessels-loaded retry
 * and opens the vessel detail sheet directly (CEO 2026-08-11: a boat-name search
 * result must reach the Directory detail in one click). peek/consume keeps it
 * idempotent — cleared only once the vessel is found + opened.
 */

let pending = null;
const listeners = new Set();

/** Request that DirectoryView open `vesselId` (vessels.id). */
export function requestVesselOpen(vesselId) {
  if (!vesselId) return;
  pending = { vesselId };
  listeners.forEach((l) => {
    try { l(); } catch { /* spine-emit-ok: a listener error must not break navigation */ }
  });
}

/** Read the pending request without clearing it (so a failed open can retry). */
export function peekVesselOpen() { return pending; }

/** Read + clear the pending request (call only once you've handled it). */
export function consumeVesselOpen() { const p = pending; pending = null; return p; }

/** Subscribe to new requests; returns an unsubscribe fn. */
export function subscribeVesselOpen(cb) { listeners.add(cb); return () => listeners.delete(cb); }

/** Test helper. */
export function _resetVesselNav() { pending = null; listeners.clear(); }
